import {Component, Input} from '@angular/core';

declare var $: any;

@Component({
  selector: 'admin-nav',
  templateUrl: './admin-nav.template.html',
  styleUrls: ['admin-nav.style.css'],
})
export class AdminNavComponent {
  data: any;

  @Input() type: string;
  public menuHide = false;
  // code_chonggia = 1;
  // code_baohanh = 2;
  // code_tranhang = 3;
  // code_dinhdanh = 5;
  status_chonggia = false;
  status_baohanh = false;
  status_tranhang = false;
  status_dinhdanh = false;
  isOpen = false;
  source = Number(JSON.parse(localStorage.getItem("User")).source)
  public checkValidateAccount: any;

  constructor() {
  }

  ngOnInit() {
    $('.menu-content .card .collapse-li a').click(function () {
      if (!$(this).find('i').hasClass('rotate')) {
        $('.menu-content .card li a').find('i').removeClass('rotate');
        $(this).find('i').addClass('rotate');
      } else {
        $('.menu-content .card li a').find('i').removeClass('rotate');
      }
    });
    let userInfo = localStorage.getItem('User');
    let service = JSON.parse(userInfo).services.split(',');
    service.map((res) => {
      if (Number(res.trim()) === 1) {
        this.status_chonggia = true
      } else if (Number(res.trim()) === 2) {
        this.status_baohanh = true

      } else if (Number(res.trim()) === 3) {
        this.status_tranhang = true

      } else if (Number(res.trim()) === 5) {
        this.status_dinhdanh = true

      }
    })
  setInterval(() => {
    this.checkValidateAccount = localStorage.getItem('checkValidateAccount')
    // console.log('checkValidateAccount22222', this.checkValidateAccount)
    // console.log('checkValidateAccount22222333',localStorage.getItem('checkValidateAccount'))
  }, 1000)
  }

  openSubMenu() {
    this.isOpen = !this.isOpen;
  }

  toggleMenu() {
    if (!this.menuHide) {
      $('.site-menubar').addClass('menu_hide');
      $('#evs_page').addClass('has_menu');
      this.menuHide = true;
    } else {
      $('.site-menubar').removeClass('menu_hide');
      $('#evs_page').removeClass('has_menu');
      this.menuHide = false;
    }
  }
}



// WEBPACK FOOTER //
// /app/src/app/layout/navigation/admin-nav.component.ts